export default import.meta.ROLLDOWN_FILE_URL_jGgojnaW$i535TJjps$I7w